import React from 'react';

import withPageComponents from '../../../page/components/with-page-components';
import JsonLd from '../../../shared/components/json-ld';
import { getProductJsonLdData } from '../../../product/components/product-json-ld';

const mapProperties = data => {
    return data.reduce((acc, item) => {
        const { display, optionitems } = item || {};
        const selectedOption = optionitems.find(option => option.selected === 'true' && option.display === 'true');
        if (display !== 'true' || !selectedOption) {
            return acc;
        }
        acc.push({
            '@type': 'PropertyValue',
            name: item.title,
            value: selectedOption.name,
        });
        return acc;
    }, []);
};

function convertToSchemaProductGroup(data, seo = {}, productSchema = null) {
    try {
        if (!data) {
            return null;
        }
        const { image } = data || {};
        const productGroup = {
            '@context': 'https://schema.org',
            '@type': 'ProductGroup',
            name: seo.title || data.name,
            image,
            productGroupID: data.sku,
            description: seo.description || data.shortDescription || data.longDescription || '',
            ...(data?.specCategories?.length > 0 ? { additionalProperty: mapProperties(data.specCategories) } : {}),
            url: seo.canonical,
            mpn: data.sku,
            sku: data.sku,
            brand: {
                '@type': 'Brand',
                name: 'HP',
            },
            ...(productSchema
                ? {
                      hasVariant: [
                          {
                              '@type': 'Product',
                              sku: productSchema.sku,
                              name: productSchema.name,
                              url: productSchema.url,
                              image: image,
                              ...(productSchema.offers ? { offers: productSchema.offers } : {}),
                              ...(productSchema.aggregateRating
                                  ? { aggregateRating: productSchema.aggregateRating }
                                  : {}),
                          },
                      ],
                  }
                : {}),
        };
        return productGroup;
    } catch (error) {
        return null;
    }
}

export default withPageComponents(
    React.memo(({ data, ctoProductInitial: product, baseConfig, price, seo }) => {
        if (!price || !price.salePrice) {
            return null;
        }
        const schemaData = [...(data || [])];
        let { image } = baseConfig || {};
        const productSchema =
            product && product.name
                ? getProductJsonLdData({ ...product, price, linkUrl: seo?.canonical || product.linkUrl }, seo)
                : null;
        let productGroup = convertToSchemaProductGroup({ ...baseConfig, image }, seo, productSchema);

        if (productGroup) {
            // merge product schema with product group schema
            productGroup = { ...(productSchema || {}), ...productGroup };
            if (productGroup.offers) {
                productGroup.offers.availability = 'https://schema.org/InStock';
            }
            schemaData.push({ type: 'product-group', data: productGroup });
        }

        return schemaData.length > 0 ? (
            <JsonLd id="cto-schema-markup" data={schemaData} shouldNotUseDefaults={true} renderInHead={true} />
        ) : null;
    }),
    { components: ['ctoProductInitial', 'baseConfig'], seo: true },
);
